<template>
  <div class="listPage">
    <div class="banner">
      <img src="../../../assets/images/banner3.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon3">
        <i class="iconfont icon-pinpaizichanpingtai"></i>
      </div>
      <div class="breadcrumb_item">物流&订单管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">订单支付收款管理</div>
    </div>

    <div class="input_box flex-between">
      <van-field
        v-model="params.keyword"
        placeholder="输入关键字查找→"
        @focus="handleFocus"
        @blur="handleBlur"
        @keyup.enter="handleSearch"
      />
      <i class="iconfont icon-sousuo" @click="handleSearch"></i>
    </div>

    <div class="order_wrap">
      <template v-if="dataList.length > 0">
        <div
          class="order_item"
          v-for="item in dataList"
          :key="item.id"
          @click="handleDetail(item.id)"
        >
          <div class="row_one mb">
            <p>付款方式：{{ item.paytype }}</p>
            <p>付款抬头：{{ item.headname }}</p>
            <p>付款开户行：{{ item.bankname }}</p>
            <p>付款账号：{{ item.bankaccount }}</p>
          </div>

          <div class="row_one mb">
            <p>付款金额：¥ {{ item.paynum | formatPrice }}</p>
            <p>实际订单价格：¥ {{ dataItem.price | formatPrice }}</p>
            <!-- <p>剩余差额：¥ {{ item.remain | formatPrice }}</p> -->
          </div>

          <div class="row_one mb">
            <p>付款记录创建人：{{item.createuser}}</p>
            <p>付款记录创建日期：{{item.createdate | formatDate}}</p>
            <p>付款记录审核人：{{item.checkuser}}</p>
            <p>付款记录审核日期：{{item.checkdate | formatDate}}</p>
            <p class="red">付款记录审核状态：<span>{{ item.checkstate }}</span></p>
          </div>
        </div>
      </template>
      <van-empty
        v-else-if="dataList.length == 0 && !loading"
        description="暂无申请记录"
      />
    </div>
    <!-- <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回业务中心
    </div> -->

    <div class="fixd_button_btm flex-rowl" v-if="isShowTabbar">
      <div class="item" :class="{'return' : state == 'shdj'}" @click="handleReturn">返回</div>
      <div class="item" @click="handleDetail('')" v-if="state == 'shdj'">添加收款记录</div>
    </div>

    <!-- <Tabbar v-if="isShowTabbar"></Tabbar> -->
  </div>
</template>

<script>
import { encryptstringview, encryptstringadd } from "../../../api/api";
import { getOrderPaymentList, getOrderListDetail } from "../../../api/shop";
// import { calculator } from "../../../utils/decimal";
// import Tabbar from "../../../components/Tabbar.vue";
import { mapState } from "vuex";
export default {
  name: "cPaymentList",
  components: {
    // Tabbar,
  },
  data() {
    return {
      state: "", // sk=订单收款管理、sh=订单审核管理
      isShowTabbar: true,
      qyid: "",
      dataList: [],
      type: "",
      params: {
        orderno: "",
        keyword: "",
      },
      listTotal: 0,
      loading: false, // 是否正在加载中
       dataItem: '',  // 订单详情
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
     // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) "0.00";
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    if (USERINFO.qy) {
      this.qyid = USERINFO.qy.qyid;
    } else {
      this.qyid = 0;
    }

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { orderno, orderId, orderOpenid, state } = JSON.parse(res.jsondata);
        console.log(state,'===-==-=');
        this.orderId = orderId;
        this.orderOpenid = orderOpenid;
        this.params.orderno = orderno;
        this.state = state
        this.getOrderPaymentList();
        this.getOrderListDetail(orderId, orderOpenid)
      } else {
        this.$router.back();
      }
    },

    // 搜索
    handleSearch() {
      this.getOrderPaymentList();
    },

    getOrderPaymentList() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loading = true;
      getOrderPaymentList(this.params).then((res) => {
        res.list.sort((a, b) => b.createdate.localeCompare(a.createdate))
        this.dataList = res.list;
        this.listTotal = res.total;
        this.loading = false;
        Toast.clear();
      });
    },

    handleDetail(id) {
      let { orderno } = this.params;
      let { orderId, orderOpenid, state } = this;
      if (id) {
        this.encryptstringadd("cPaymentDetail", {
          orderno,
          id,
          orderId,
          orderOpenid,
          type: state == 'shdj' ? 1 : 2
        });
        // this.$router.push({ path: "/brandIndex/brandDetail", query: { id } });
      } else {
        this.encryptstringadd("cPaymentDetail", {
          orderno,
          id: "",
          orderId,
          orderOpenid,
          type: state == 'shdj' ? 1 : 2
        });
      }
    },

    // 订单列表
    getOrderListDetail(id, openid) {
      let params = {
        openid: openid,
        orderid: id,
      };
      this.loading = true;
      getOrderListDetail(params).then((res) => {
        let newObj = res[0];
        this.dataItem = newObj;
      });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    handleReturn() {
      this.$router.back();
    },

    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },
  },
};
</script>
<style lang="less" scoped>
.listPage {
  padding-bottom: 300px;
  .screen_wrap {
    font-size: 20px;
    color: #464646;
    flex-wrap: wrap;
    margin: 70px 70px 60px;
    .item {
      border: 1px solid #d2d2d2;
      height: 40px;
      line-height: 40px;
      padding: 0 10px 0 19px;
      margin-right: 10px;
      margin-bottom: 20px;
      span {
        width: 40px;
        display: inline-block;
        margin-left: 20px;
        .iconfont {
          font-size: 30px;
        }
      }
    }
  }
  .order_wrap {
    margin-top: 40px;
    .order_item {
      width: 650px;
      border: 1px solid #d2d2d2;
      margin: 0 auto 30px;
      padding: 40px;
      font-size: 20px;
      color: #3c3c3c;
      box-sizing: border-box;
      .row_one {
        font-size: 22px;
        &.mb {
          margin-bottom: 30px;
        }
        p {
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .row_shop_list {
        margin: 27px 0 55px;
        color: #3c3c3c;
        .shop_item {
          margin-bottom: 30px;
        }
        .shop_name_num {
          margin-bottom: 22px;
          .shop_name_num_item {
            align-items: flex-start;
            margin-bottom: 4px;
          }
          p {
            font-size: 20px;
            &.label {
              white-space: nowrap;
            }
          }
        }
        .shop_price {
          font-size: 18px;
          .txt {
            margin-top: 10px;
          }
        }
      }
      .row_two {
        margin-bottom: 40px;
        p {
          margin-bottom: 6px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .row_three {
        margin-bottom: 36px;
        font-size: 22px;
      }
      .row_four {
        margin-bottom: 30px;
        font-size: 22px;
        span {
          margin-right: 17px;
        }
        .txt {
          margin-bottom: 10px;
          p {
            // &:last-child {
            //   font-size: 30px;
            // }
          }
          span {
            font-size: 20px;
          }
        }
        .txt1 {
          margin-bottom: 30px;
        }
      }
      .order_status {
        font-size: 22px;
        .txt {
          margin-bottom: 10px;
        }
        
      }
    }
  }
  .red {
          color: #ee0032;
        }
}
</style>